module.exports = "/_next/static/images/1b5fbfea66362fa4349af8b6af8c5323-cajita-nu.png";